import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import { PopupsConsumer } from "../../../helpers/contexts/popupsContext";

const ProgressBar = (props) => {
  const { progressBarTime } = props;

  const [time, setTime] = useState(0);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (progressBarTime) {
      const interval = setInterval(() => {
        if (time < progressBarTime) {
          setTime(time + 1000);
          setPercent(Math.ceil((time / progressBarTime) * 100));
        } else {
          setPercent(100);
          clearInterval(interval);
          setTimeout(() => {
            setPercent(0);
          }, 1500);
        }
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    } else {
      setTime(0);
      setPercent(0);
    }
  }, [progressBarTime, time]);

  return (
    <PopupsConsumer>
      {() => (
        <React.Fragment>
          <div
            className={
              (percent === 100 && "progress-bar-container fadeout") ||
              "progress-bar-container"
            }
          >
            <div className="progress-bar" style={{ width: `${percent}%` }} />
          </div>
        </React.Fragment>
      )}
    </PopupsConsumer>
  );
};

export default ProgressBar;
